<!-- Outer container -->
<div
    class="outer-container"
    [style.backgroundColor]="model.backgroundColor">
    <!-- Inner container -->
    <div
        [style.backgroundColor]="model.bannerSetting.backgroundColor"
        [style.border]="'thin solid ' + model.borderColor">
         <!-- Header -->
        <div
            *ngIf="model.headerSetting.showContent || model.headerSetting.showText"
            class="header-contents">
            <div
                [ngClass]="(model.headerSetting.headerContentSetting.isPositionSticky && model.headerSetting.headerTextSetting.isPositionSticky) ? '' : 'header-contents'"
                [style.position]="(contentContextType === ContentContextType.Page && model.headerSetting.headerContentSetting.isPositionSticky && model.headerSetting.headerTextSetting.isPositionSticky) ? 'sticky' : 'auto'"
                [style.top]="(contentContextType === ContentContextType.Page && model.headerSetting.headerContentSetting.isPositionSticky && model.headerSetting.headerTextSetting.isPositionSticky) ? '0' : 'auto'"
                [style.zIndex]="(contentContextType === ContentContextType.Page && model.headerSetting.headerContentSetting.isTopStackOrder && model.headerSetting.headerTextSetting.isPositionSticky) ? '9999' : 'auto'">
                <!-- Content -->
                <div
                    *ngIf="model.headerSetting.showContent && (model.headerSetting.contents | filterContentUrl : language)"
                    [style.backgroundColor]="model.headerSetting.headerContentSetting.backgroundColor"
                    [style.paddingTop]="model.headerSetting.headerContentSetting.padding?.top + 'px'"
                    [style.paddingBottom]="model.headerSetting.headerContentSetting.padding?.bottom + 'px'"
                    [style.paddingLeft]="model.headerSetting.headerContentSetting.padding?.left + 'px'"
                    [style.paddingRight]="model.headerSetting.headerContentSetting.padding?.right + 'px'"
                    [style.textAlign]="model.headerSetting.headerContentSetting.alignmentType | alignment"
                    [style.position]="(contentContextType === ContentContextType.Page && model.headerSetting.headerContentSetting.isPositionSticky && !model.headerSetting.headerTextSetting.isPositionSticky) ? 'sticky' : 'static'"
                    [style.top]="(contentContextType === ContentContextType.Page && model.headerSetting.headerContentSetting.isPositionSticky && !model.headerSetting.headerTextSetting.isPositionSticky) ? '0' : 'auto'"
                    [style.zIndex]="(contentContextType === ContentContextType.Page && model.headerSetting.headerContentSetting.isTopStackOrder && !model.headerSetting.headerTextSetting.isTopStackOrder) ? '9997' : 'auto'">
                    <img
                        [src]="model.headerSetting.contents | filterContentUrl : language"
                        class="img-fluid header-content"
                        [style.width]="model.headerSetting.headerContentSetting.isFullWidth ? '100%' : 'auto'"
                        [style.height]="model.headerSetting.headerContentSetting.isFullWidth ? 'auto' : model.headerSetting.headerContentSetting.height + 'px'" />
                </div>
                <!-- Text -->
                <div
                    *ngIf="model.headerSetting.showText && (model.headerSetting.translations | filterLanguage: language)"
                    [style.backgroundColor]="model.headerSetting.headerTextSetting.backgroundColor"
                    [style.paddingTop]="model.headerSetting.headerTextSetting.padding?.top + 'px'"
                    [style.paddingBottom]="model.headerSetting.headerTextSetting.padding?.bottom + 'px'"
                    [style.paddingLeft]="model.headerSetting.headerTextSetting.padding?.left + 'px'"
                    [style.paddingRight]="model.headerSetting.headerTextSetting.padding?.right + 'px'"
                    [style.position]="(contentContextType === ContentContextType.Page && model.headerSetting.headerTextSetting.isPositionSticky && !model.headerSetting.headerContentSetting.isPositionSticky) ? 'sticky' : 'static'"
                    [style.top]="(contentContextType === ContentContextType.Page && model.headerSetting.headerTextSetting.isPositionSticky && !model.headerSetting.headerContentSetting.isPositionSticky) ? '0' : 'auto'"
                    [style.zIndex]="(contentContextType === ContentContextType.Page && model.headerSetting.headerTextSetting.isTopStackOrder && !model.headerSetting.headerContentSetting.isTopStackOrder) ? '9997' : 'auto'">
                    <div [innerHtml]="(model.headerSetting.translations | filterLanguage: language) | keepHtml"></div>
                </div>
            </div>
        </div>
        <!-- Banner -->
        <ng-container *ngIf="model.bannerSetting.showContent !== false">
            <!-- Banner page -->
            <div
                *ngIf="contentContextType === ContentContextType.Page && (model.bannerSetting.contents | filterContentUrl : language : contentContextType : mediaTypePage)"
                [style.backgroundColor]="model.bannerSetting.backgroundColor"
                #bannerBlock
            >
                <img
                    *ngIf="mediaTypePage !== ContentMediaType.Video"
                    [src]="model.bannerSetting.contents | filterContentUrl : language : contentContextType : mediaTypePage"
                    class="img-fluid"
                    width="100%"
                    height="auto" />
                <video
                    *ngIf="mediaTypePage === ContentMediaType.Video"
                    width="100%"
                    autoplay
                    [muted]="true"
                    loop>
                    <source
                        [src]="model.bannerSetting.contents | filterContentUrl : language : contentContextType : mediaTypePage"
                        type="video/mp4" />
                </video>
            </div>
            <!-- Banner email -->
            <div
                *ngIf="contentContextType === ContentContextType.Email && (model.bannerSetting.contents | filterContentUrl : language : contentContextType : mediaTypeEmail)"
                [style.backgroundColor]="model.bannerSetting.backgroundColor">
                <img
                    [src]="model.bannerSetting.contents | filterContentUrl : language : contentContextType : mediaTypeEmail"
                    class="img-fluid"
                    width="100%"
                    height="auto" />
            </div>
        </ng-container>
        <!-- Body -->
        <div
            class="inner-block">
            <!-- Content page -->
            <div
                *ngIf="contentContextType === ContentContextType.Page">
                <div
                    class="inner-content-block"
                    [style.position]="model.contentSetting.isBelowBanner ? 'static' : 'relative'"
                    [style.zIndex]="(model.headerSetting.headerTextSetting.isTopStackOrder || model.headerSetting.headerContentSetting.isTopStackOrder) ? 'auto' : '9995'"
                    [style.width]="model.contentSetting.width + '%'"
                    [style.marginTop]="contentTopMargin()"
                    [style.marginBottom]="model.contentSetting.marginBottom + '%'"
                    [style.marginLeft]="model.contentSetting.alignmentType === 1 ? model.contentSetting.marginX + '%' : 'auto'"
                    [style.marginRight]="model.contentSetting.alignmentType === 3 ? model.contentSetting.marginX + '%' : 'auto'"
                    [style.border]="model.contentSetting.borderWidth + 'px' + ' solid ' + model.contentSetting.borderColor"
                    [style.borderRadius]="model.contentSetting.borderRadius + 'px'"
                    [style.paddingTop]="model.contentSetting.padding?.top + 'px'"
                    [style.paddingBottom]="model.contentSetting.padding?.bottom + 'px'"
                    [style.paddingLeft]="model.contentSetting.padding?.left + 'px'"
                    [style.paddingRight]="model.contentSetting.padding?.right + 'px'">
                    <!-- Block title -->
                    <div
                        *ngIf="model.contentSetting.contentTitleSetting.showContentTitle && (model.contentSetting.titleTranslations | filterLanguage: language)"
                        [style.backgroundColor]="model.contentSetting.contentTitleSetting.backgroundColor">
                        <div
                            class="px-md-4 px-3"
                            [style.color]="model.contentSetting.contentTitleSetting.textColor"
                            [style.fontFamily]="model.contentSetting.contentTitleSetting.fontFamily"
                            [innerHtml]="(model.contentSetting.titleTranslations | filterLanguage: language) | keepHtml"></div>
                        <!-- <hr
                            class="m-0 p-0"
                            [style.border]="model.contentSetting.borderWidth + 'px' + ' solid ' + model.contentSetting.borderColor" /> -->
                    </div>
                    <!-- Menu -->
                    <div
                        class="p-md-3 p-2"
                        [style.backgroundColor]="model.contentSetting.contentTitleSetting.backgroundColor"
                        [style.fontFamily]="model.contentSetting.contentTitleSetting.fontFamily">
                        <ng-container *ngIf="!useContentPage">
                            <h4
                                [style.color]="model.contentSetting.contentTitleSetting.textColor"
                                [style.fontFamily]="model.contentSetting.contentTitleSetting.fontFamily"
                                [style.textAlign]="model.contentSetting.contentMenuSetting.alignmentType | alignment">
                                {{ 'ROUTES.TEMPLATES.ADVANCEDTEMPLATES.PREVIEW.MENU.LABEL' | translate }}
                            </h4>
                        </ng-container>
                        <ng-container *ngIf="useContentPage">
                            <!-- Menu -->
                            <ng-content select="[pageMenu]"></ng-content>
                        </ng-container>
                        <!-- <hr
                            class="m-0 p-0"
                            [style.border]="model.contentSetting.borderWidth + 'px' + ' solid ' + model.contentSetting.borderColor" /> -->
                    </div>
                    <!-- Block -->
                    <div
                        [style.backgroundColor]="model.contentSetting.contentBlockSetting.backgroundColor">
                        <!-- Text -->
                        <div
                            class="p-md-4 p-3"
                            [style.color]="model.contentSetting.contentBlockSetting.textColor"
                            [style.fontFamily]="model.contentSetting.contentBlockSetting.fontFamily">
                            <ng-container *ngIf="!useContentPage">
                                {{ 'ROUTES.TEMPLATES.ADVANCEDTEMPLATES.PREVIEW.TEXT.LABEL' | translate }}
                            </ng-container>
                            <ng-container *ngIf="useContentPage">
                                <!-- Content -->
                                <ng-content select="[pageContents]"></ng-content>
                            </ng-container>
                        </div>
                        <!-- Buttons -->
                        <div 
                            *ngIf="!useContentPage" 
                            [class]="'p-md-4 p-3 flex-column ' + (model.buttonSetting.alignmentType | alignmentFlex)"
                        >
                            <button
                                class="btn full-button"
                                [ngStyle]="styleService.getFullButtonStyle(model)"
                                [style.width]="model.buttonSetting.isFullWidth ? '100%' : model.buttonSetting.width + 'px'"
                                [style.borderRadius]="model.buttonSetting.borderRadius + 'px'">
                                {{ 'INPUT.BUTTON.FULL.LABEL' | translate }}
                            </button>
                            <button
                                class="btn hollow-button mt-2"
                                [ngStyle]="styleService.getHollowButtonStyle(model)"
                                [style.width]="model.buttonSetting.isFullWidth ? '100%' : model.buttonSetting.width + 'px'"
                                [style.borderRadius]="model.buttonSetting.borderRadius + 'px'">
                                {{ 'INPUT.BUTTON.HOLLOW.LABEL' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Footers -->
                <div *ngFor="let footer of model.footers | filterFooterType : contentContextType" class="inner-footers">
                    <app-footer-view [model]="footer" [language]="language"></app-footer-view>
                </div>
            </div>
            <!-- Content email -->
            <div *ngIf="contentContextType === ContentContextType.Email">
                <div
                    class="inner-content-block"
                    position="static"
                    [style.color]="model.contentSetting.contentBlockSetting.textColor"
                    [style.backgroundColor]="model.contentSetting.contentBlockSetting.backgroundColor">
                    <!-- If no preview content is passed, use sample content -->
                    <ng-container *ngIf="!useContentEmail">
                        <!-- Titles and text -->
                        <div class="p-4">
                            <h1
                                [style.color]="model.contentSetting.contentTitleSetting.textColor"
                                [style.fontFamily]="model.contentSetting.contentTitleSetting.fontFamily">
                                {{ 'ROUTES.TEMPLATES.DESIGNS.TITLE.LABEL' | translate }}
                            </h1>
                            <h4
                                [style.color]="model.contentSetting.contentBlockSetting.textColor"
                                [style.fontFamily]="model.contentSetting.contentBlockSetting.fontFamily"
                                style="text-indent: 5%;">
                                {{ 'ROUTES.TEMPLATES.DESIGNS.SMALLTITLE.LABEL' | translate }}
                            </h4>
                            <p
                                [style.color]="model.contentSetting.contentBlockSetting.textColor"
                                [style.fontFamily]="model.contentSetting.contentBlockSetting.fontFamily"
                                style="text-indent: 10%;">
                                {{ 'ROUTES.TEMPLATES.DESIGNS.TEXT.LABEL' | translate }}
                            </p>
                        </div>
                        <!-- Buttons -->
                        <div class="mb-4">
                            <div class="centered-content">
                                <button
                                    class="btn full-button m-2"
                                    [ngStyle]="styleService.getFullButtonStyle(model)"
                                    [style.width]="'100%'"
                                    [style.borderRadius]="model.buttonSetting.borderRadius + 'px'">
                                    {{ 'INPUT.BUTTON.FULL.LABEL' | translate }}
                                </button>
                            </div>
                            <div class="centered-content">
                                <button
                                    class="btn hollow-button m-2"
                                    [ngStyle]="styleService.getHollowButtonStyle(model)"
                                    [style.width]="'100%'"
                                    [style.borderRadius]="model.buttonSetting.borderRadius + 'px'">
                                    {{ 'INPUT.BUTTON.HOLLOW.LABEL' | translate }}
                                </button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="useContentEmail">
                        <!-- Content -->
                        <div class="p-4">
                            <ng-content select="[emailContents]"></ng-content>
                        </div>
                    </ng-container>
                </div>
                <!-- Footers -->
                <div *ngFor="let footer of model.footers | filterFooterType : contentContextType">
                    <app-footer-view [model]="footer" [language]="language"></app-footer-view>
                </div>
            </div>
        </div>
    </div>
</div>